import { createContext, useContext, type ReactNode } from "react";
import {
  createWorkspaceTransport,
  type WorkspaceTransport,
} from "./workspace-transport";
const legacy = createWorkspaceTransport({ demo: true });
const Context = createContext(legacy);
export const useWorkspaceTransport = () => useContext(Context);
export function WorkspaceTransportProvider({
  value,
  children,
}: {
  value: WorkspaceTransport;
  children: ReactNode;
}) {
  return <Context.Provider value={value}>{children}</Context.Provider>;
}
